import { useSession } from '@/core/auth/use-session';
import { isAdmin } from './access';

export const useAdmin = () => {
  const { data: session } = useSession();

  if (!session) {
    return false;
  }

  return isAdmin(session);
};
